__turbopack_context__.v({
  "thumbnail-cell": "index-module-scss-module__ySDc9a__thumbnail-cell",
  "thumbnail-cell--selected": "index-module-scss-module__ySDc9a__thumbnail-cell--selected",
  "thumbnail-wrapper": "index-module-scss-module__ySDc9a__thumbnail-wrapper",
});
